/**
 * Created with IntelliJ IDEA.
 * User: abahlk
 * Date: 30.01.14
 * Time: 14:52
 * To change this template use File | Settings | File Templates.
 */

import { BasicEnum, instantiationKey } from "../../constants/enums/BasicEnum";

export class DownloadedContentSourceLocationEnum extends BasicEnum {
    // list of all enumerated values
    private static _values: DownloadedContentSourceLocationEnum[] = [];

    // getter for list of all enumerated values
    public static get values(): DownloadedContentSourceLocationEnum[] {
        return DownloadedContentSourceLocationEnum._values.concat();
    }

    // declaration of enumerated values
    private static _external: DownloadedContentSourceLocationEnum = new DownloadedContentSourceLocationEnum("External", instantiationKey);
    private static _local: DownloadedContentSourceLocationEnum = new DownloadedContentSourceLocationEnum("Local", instantiationKey);

    // getters for enumerated values
    public static get External(): DownloadedContentSourceLocationEnum {
        return DownloadedContentSourceLocationEnum._external;
    }

    public static get Local(): DownloadedContentSourceLocationEnum {
        return DownloadedContentSourceLocationEnum._local;
    }

    constructor(name: string, doNotInstantiate: number) {
        super(name, doNotInstantiate);
    }
}
